import { QuotaValueFund } from '@interfaces/quota-values.interface';

export const BREAKPOINT_INFORMATION = 480;
export const FUNDS_NAMES = ['A', 'B', 'C', 'D', 'E'];
export const EMPTY_VALUE_FUNDS: QuotaValueFund = { fundA: 0, fundB: 0, fundC: 0, fundD: 0, fundE: 0 };
export const EMPTY_VALUE = [ { date: null, fundA: 0, fundB: 0, fundC: 0, fundD: 0, fundE: 0 } ];
export const COMPARISON_PERIOD = 15;
export const CHART_COMPARISON_PERIOD = 365;
